import { useContext } from "react";

import { AccessContext, type AccessContextProps } from "..";

export function useAccessContext(): AccessContextProps {
  const context = useContext(AccessContext);

  if (!context)
    throw new Error("useAccessContext must be used within AccessProvider");

  return context;
}
